import React from 'react';

import { byCreatedAtDesc } from 'util/comparators';
import { parse } from 'util/json';

export const IMAGE_ASSET_TYPE = 'image_asset';
export const COLOR_ASSET_TYPE = 'color_asset';

export function parseImageAssets(imageAssets, limit) {
  const processedImageAssets = imageAssets
    .slice(0, limit || imageAssets.length)
    .map(asset => ({
      ...asset,
      jsonData: parse(asset.jsonData)
    }))
    .sort(byCreatedAtDesc);
  return processedImageAssets;
}

export function parseColorAssets(colorAssets, limit) {
  const processedColorAssets = colorAssets
    .slice(0, limit || colorAssets.length)
    .map(asset => {
      const parsedColor = parse(asset.jsonData);
      return {
        swHexColor: parsedColor.hexValue,
        name: parsedColor.name,
        colorCode: parsedColor.slug,
        url: parsedColor.url
      };
    })
    .sort(byCreatedAtDesc);
  return processedColorAssets;
}
